import { DarkModeSwitch } from "react-toggle-dark-mode";
import { useColorScheme } from "../../../hooks/useColorScheme";

// * A functional component that renders a header component for the User Dashboard page.
//  * It renders a header component with a light/dark mode toggle switch and the title "User Dashboard".
//  * The component uses the useColorScheme hook to get the current color scheme and the setIsDark function to update the color scheme.
const MainHeader = () => {
  const { isDark, setIsDark } = useColorScheme();

  return (
    <div className="header1">
      <h2>User Dashboard</h2>
      <DarkModeSwitch
        onChange={setIsDark}
        checked={isDark}
        className="dark-mode-switch"
        animationProperties={{ duration: 400 }}
        aria-label="Dark mode toggle"
        sunColor="rgb(235, 169, 14)"
      />
    </div>
  );
};

export default MainHeader;
